import {colors, fontFamily, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import styled from '@emotion/styled';
import Button from 'patient-ping-remedy/packages/button';

const StyledInput = styled.input`
  width: 100%;
  font-size: ${fontSize.small};
  font-family: inherit;
  border: none;
  height: ${sizes.large};
  border-top: 0.1rem solid ${colors.gray2};
  border-bottom: 0.1rem solid ${colors.gray2};
  margin: 0 ${sizes.xSmall};
    
  &:focus {
    outline: none;
  }
`;

const StyledInputDiv = styled.div((props: { concise?: boolean, searchBy?: boolean }) => ({
  width: '100%',
  maxWidth: '44rem',
  minWidth: '24rem',
  fontSize: '1.5rem',
  fontFamily: `${fontFamily.default}`,
  padding: props.searchBy ? `0 0 0 ${sizes.xSmall}`: `0 ${sizes.xSmall}`,
  height: `${sizes.large}`,
  borderRadius: '8px',
  border: `0.1rem solid ${colors.gray2}`,
  background: colors.white,
  display: 'flex',
  alignItems: 'center',
  flex: '1',
}));

const StyledButton = styled(Button)`
  gap: ${sizes.xxSmall};
  padding: 0.8rem;
  white-space: nowrap;
  
  & > span {
    color: inherit;
  }
`;

export {StyledInput, StyledInputDiv, StyledButton};
